import { lazy } from 'react';

import { PageSuspense } from 'src/components';


const ProductCartUpdatePage = lazy(() => import('../views/update/ProductCartUpdatePage'));

export function ProductCartUpdatePageLazy() {
	return (
		<PageSuspense>
			<ProductCartUpdatePage />
		</PageSuspense>
	);
}
